
define('app/dashboard/purchase/views/purchaseView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/collections/productCollection',
	
	//Shims
	'jquery.uniform'
], function($, _, Backbone, UserModel, ProductCollection){
	var Event = _.extend({}, Backbone.Events);
	
	//Models
	var PaypalTrans = Backbone.Model.extend({
		idAttribute: 'token',
		defaults: {
			token: null,
			userName: null,
			prodId: null
	    },
	    
	    urlRoot: function() {
			return '/draftapp/users/' + this.get("userName") + '/products/' + this.get("prodId") + '/purchase/paypal';
		},

		initialize: function() {
			
	    }
	});

	var CreditTrans = Backbone.Model.extend({
		idAttribute: 'cardToken',
		defaults: {
			cardToken: null,
			userName: null,
			prodId: null,
			payStatus: null
	    },
	    
	    urlRoot: function() {
			return '/draftapp/users/' + this.get("userName") + '/products/' + this.get("prodId") + '/purchase/stripe';
		},

		initialize: function() {
			
	    }
	});

	//Views
	var ProductPurchaseFooterView = Backbone.View.extend({
		events: {
			'click #purchaseFormSubmit': 'submitProdForm',
			'click #purchaseCreditFormSubmit': 'submitCreditForm'
		},
		
		initialize: function(options) {
			this.listenTo(Event, 'default', this.showForm);
			this.listenTo(Event, 'error', this.showForm);
			this.listenTo(Event, 'creditError', this.showCreditForm);
			this.listenTo(Event, 'creditPaymentError', this.showCreditForm);
			this.listenTo(Event, 'creditDeclineError', this.showForm);
			this.listenTo(Event, 'creditInvalidError', this.showCreditForm);
			this.listenTo(Event, 'creditAccept', this.hideAll);
			this.listenTo(Event, 'creditPend', this.hideAll);
			this.listenTo(Event, 'creditDuplicate', this.hideAll);
			this.listenTo(Event, 'paypalError', this.showForm);
			this.listenTo(Event, 'creditForm', this.showCreditForm);
			this.listenTo(Event, 'paypal', this.hideAll);
			this.listenTo(Event, 'credit', this.hideAll);
			this.listenTo(Event, 'promoSuccess', this.hideAll);
		},
		
		submitProdForm: function () {
			Event.trigger("submitProdPurch");
		},
		
		submitCreditForm: function () {
			Event.trigger("submitCredit");
		},
		
		showForm: function () {
			this.hideAll();
			this.$("#purchaseSubmitFooter").show();
		},
		
		showCreditForm: function () {
			this.hideAll();
			this.$("#purchaseCreditSubmitFooter").show();
		},
		
		hideAll: function () {
			this.$("#purchaseSubmitFooter").hide();
			this.$("#purchaseCreditSubmitFooter").hide();
		},
	});

	var ProductPurchaseContentView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel;
			this.hideAll();
			this.populateDates();
			
			this.prodInputContainer = this.$("#purchaseProdInputContainer");
			this.prodTemplate = _.template($('#purchaseProdInputTemplate').html().trim());
			
			_.bindAll(this, 'selectProd');
			_.bindAll(this, 'promoLookup');
			
			this.listenTo(Event, 'default', this.formInitial);
			this.listenTo(Event, 'error', this.form);
			this.listenTo(Event, 'creditError', this.creditForm);
			this.listenTo(Event, 'creditPaymentError', this.creditForm);
			this.listenTo(Event, 'creditDeclineError', this.form);
			this.listenTo(Event, 'creditInvalidError', this.creditForm);
			this.listenTo(Event, 'creditAccept', this.success);
			this.listenTo(Event, 'creditPend', this.clearValues);
			this.listenTo(Event, 'creditDuplicate', this.clearValues);
			this.listenTo(Event, 'paypalError', this.form);
			this.listenTo(Event, 'submitProdPurch', this.submit);
			this.listenTo(Event, 'submitCredit', this.submitCredit);
			this.listenTo(Event, 'creditForm', this.creditForm);
			this.listenTo(Event, 'paypal', this.processing);
			this.listenTo(Event, 'credit', this.processing);
			this.listenTo(Event, 'promoSuccess', this.success);
			
			//Error handling
			this.listenTo(Event, 'error:prod', this.errorProd);
			this.listenTo(Event, 'error:payment', this.errorRadioPayment);
			this.listenTo(Event, 'error:card', this.errorCard);
			this.listenTo(Event, 'error:exp', this.errorExp);
			this.listenTo(Event, 'error:cvc', this.errorCVC);
			this.listenTo(Event, 'error:promoCode', this.errorPromoCode);
			
			this.$('#promoCodeLookupFormSubmit').on('click', this.promoLookup);
		},
		
		submit: function () {
			var purMethodValue = this.$('input[name=purMethod]:checked').val();
			var purProdValue = this.$('input[name=purProd]:checked').val();
			var prodError = false;
			var paymentError = false;
			
			if(!purProdValue || purProdValue == ""){
				prodError = true;
			} 
			
			if (!purMethodValue	|| purMethodValue == ""){
				paymentError = true;
			}
			
			if(prodError || paymentError){
				Event.trigger("error");
				if(prodError){
					Event.trigger("error:prod", "NULL");
				}
				if(paymentError){
					Event.trigger("error:payment", "NULL");
				}
			} else {
				switch (purMethodValue){
					case "credit": 
						Event.trigger("creditForm", purProdValue);
						break;
					case "paypal": 
						Event.trigger("paypal", purProdValue);
						break;
					default : 
						Event.trigger("error");
				}
			}
		},
		
		submitCredit: function () {
			var cardNum = this.$("#creditNumberInput").val();
			var expMonth = this.$("#creditMonthInput").val();
			var expYear = this.$("#creditYearInput").val();
			var cvcNum = this.$("#creditCvcInput").val();
			var prodId = this.$('input[name=purProd]:checked').val();
			
			var cardError = false;
			var expError = false;
			var cvcError = false;
			
			if(!Stripe.validateCardNumber(cardNum)){
				cardError = true;
			}
			
			if(!Stripe.validateExpiry(expMonth, expYear)){
				expError = true;
			}
			
			if(!Stripe.validateCVC(cvcNum)){
				cvcError = true;
			}
			
			if(cardError || expError || cvcError){
				Event.trigger("creditError");
				if(cardError){
					Event.trigger("error:card");
				}
				if(expError){
					Event.trigger("error:exp");
				}
				if(cvcError){
					Event.trigger("error:cvc");
				}
			} else {
				Event.trigger("credit", prodId, cardNum, cvcNum, expMonth, expYear);
			}
		},
		
		promoLookup: function() {
			event.preventDefault();
			this.hideErrors();
			
			var purProdValue = this.$('input[name=purProd]:checked').val();
			var promo = this.$("#promoCodeInput").val();
			var promoError = false;
			var prodError = false;
			
			if(!promo || promo == ""){
				promoError = true;
			}
			if(!purProdValue || purProdValue == ""){
				prodError = true;
			}
			
			if(promoError || prodError){
				if(promoError){
					Event.trigger("error:promoCode");
				}
				if(prodError) {
					Event.trigger("error:prod", "NULL");
				}				
			} else {
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : 
						'/draftapp/users/'
						+ this.userModel.get('userName')
						+ '/products/'
						+ purProdValue
						+ '/purchase/promo/' 
						+ promo,
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : promo,
					success: function(data, status) {
						Event.trigger("promoSuccess");
					},
					error: function(data, status) {
						Event.trigger("error:promoCode");
					}
				});
			}
		},
		
		selectProd: function () {
			var selectedProdTypeId = this.$('input[name=purProd]:checked').val();
			
			if(selectedProdTypeId && selectedProdTypeId != ""){
				var prodModel = this.model.retrieveProdWithProdTypeId(selectedProdTypeId);
				var prodTypeModel = prodModel.get("productTypes").get(selectedProdTypeId);

				var maxBought = prodModel.maxBoughtPrice();
				var price = (prodTypeModel.get("price") - maxBought).toFixed(2);
				var desc = prodModel.get('sport') + " " + prodModel.get('year') + " " + prodTypeModel.prettyProdDesc();				
				
				this.$('#prodDisplayProduct').html(desc);
				this.$('#prodDisplaySport').html(prodModel.get('sport'));
				this.$('#prodDisplayPrice').html('$' + price);
				
				this.$('#finalProdDesc').html(desc);
				this.$('#finalProdPrice').html('$' + price);				
				
			} else {
				this.$('#prodDisplayProduct').html('Product Not Selected');
				this.$('#prodDisplaySport').html('Product Not Selected');
				this.$('#prodDisplayPrice').html('Product Not Selected');
			}
		},
		
		populateDropdown: function () {				
			var purchasableProducts = this.model.activePurchasableProducts();
			
			this.prodInputContainer.empty();
			
			this.numPurchasableProdTypes = 0;
			_.each(purchasableProducts, function(prod){
				this.numPurchasableProdTypes += _.size(prod.activePurchasableProducts());
			}, this);
			
			_.each(purchasableProducts, function(prod){
				this.prod = prod;
				//Determine if a previous product was purchased to determine upgrade price
				this.maxBought = prod.maxBoughtPrice();
				
				var sortedProdTypes = prod.get("productTypes").sortBy(function(prodType){
					return prodType.get('price');
				}, this).reverse();
				
				_.each(sortedProdTypes, function(prodType){
					if(prodType.get('price') > this.maxBought){
						var checked = this.numPurchasableProdTypes == 1 ? 'checked="checked"' : '';
						var price = (prodType.get("price") - this.maxBought).toFixed(2);
						var prodDesc = 
							this.prod.get('sport') 
							+ " "
							+ this.prod.get('year') 
							+ " " 
							+ prodType.prettyProdDesc()
							+ " - $" 
							+ price;
						
						var builtEl = $(this.prodTemplate({
							value: prodType.get('id'),
							checked: checked,
							desc: prodDesc
						}));
						
						//Disable nfl until it's released
						//if(this.prod.get('sport').toUpperCase() == 'NFL' && !$(document).getUrlParam('earlyNfl')){
						//	return;
						//}
						
						this.prodInputContainer.append(builtEl);
					}
				}, this);
				
				delete this.maxBought;
				delete this.prod;
			}, this);
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
			this.$("input[name='purProd']").change(this.selectProd);
			
			if(this.numPurchasableProdTypes == 1){
				this.selectProd();
			}
			
			delete this.numPurchasableProdTypes;
		},
		
		populateDates: function () {				
			var year = new Date().getFullYear();
			
			//Add month options
		    for (var i = 1; i <= 12; i++) {
		        this.$("#creditMonthInput").append("<option value='"+i+"' >"+i+"</option>");
		    }
		    
		    //Add year options
		    for (var i = 0; i < 12; i++) {
		        this.$("#creditYearInput").append("<option value='"+(i + year)+"' >"+(i + year)+"</option>");
		    }
		    
		    $(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		hideAll: function() {
			this.$("#purchaseBodyContentForm").hide();
			this.$("#purchaseBodyContentCreditForm").hide();
			this.$("#purchaseBodyContentProcessing").hide();
			this.$("#purchaseBodyContentSuccess").hide();
			
			this.hideErrors();
		},
		
		hideErrors: function() {
			//Hide error messages
			this.$("#purchaseProdGrp").removeClass("error");
			this.$("#purchaseProdErrMsg").hide();
			this.$("#purchaseMethodGrp").removeClass("error");
			this.$("#purchaseMethodErrMsg").hide();
			this.$("#creditNumberGrp").removeClass("error");
			this.$("#creditNumberInput").removeClass("error");
			this.$("#creditNumberErrMsg").hide();
			this.$("#creditCvcGrp").removeClass("error");
			this.$("#creditCvcInput").removeClass("error");
			this.$("#creditCvcErrMsg").hide();
			this.$("#creditDateSelGrp").removeClass("error");
			this.$("#creditDateSelErrMsg").hide();
			this.$("#purchasePromoGrp").removeClass("error");
			this.$("#promoCodeErrMsg").hide();
		},

		clearValues: function() {
			this.hideAll();
			
			this.$("#creditNumberInput").val("");
			this.$("#creditMonthInput").val("");
			this.$("#creditYearInput").val("");
			this.$("#creditCvcInput").val("");
		},
		
		form: function () {
			this.hideAll();
			this.clearValues();
			this.$("#purchaseBodyContentForm").show();
		},
		
		formInitial: function () {
			this.populateDropdown();
			this.form();
		},
		
		creditForm: function () {
			this.hideAll();
			this.selectProd();
			this.$("#purchaseBodyContentCreditForm").show();
		},
		
		processing: function () {
			this.hideAll();
			this.$("#purchaseBodyContentProcessing").show();
		},
		
		success: function () {
			this.hideAll();
			this.clearValues();
			this.$("#purchaseBodyContentSuccess").show();
		},
		
		errorProd : function (errorCode) {
			this.$("#purchaseProdGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#purchaseProdErrMsg").html("You must first select a product to purchase");
					this.$("#purchaseProdErrMsg").show();
					break;
				default : 
					this.$("#purchaseProdErrMsg").html("Product selection is invalid");
					this.$("#purchaseProdErrMsg").show();
			}
		},
		
		errorRadioPayment : function (errorCode) {
			this.$("#purchaseMethodGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#purchaseMethodErrMsg").html("You must select a payment method");
					this.$("#purchaseMethodErrMsg").show();
					break;
				default : 
					this.$("#purchaseMethodErrMsg").html("Payment method is invalid");
					this.$("#purchaseMethodErrMsg").show();
			}
		},
		
		errorCard : function () {
			this.$("#creditNumberGrp").addClass("error");
			this.$("#creditNumberInput").addClass("error");
			this.$("#creditNumberErrMsg").show();
		},
		
		errorCVC : function () {
			this.$("#creditCvcGrp").addClass("error");
			this.$("#creditCvcInput").addClass("error");
			this.$("#creditCvcErrMsg").show();
		},
		
		errorExp : function () {
			this.$("#creditDateSelGrp").addClass("error");
			this.$("#creditDateSelErrMsg").show();
		},
		
		errorPromoCode: function () {
			this.$("#purchasePromoGrp").addClass("error");
			this.$("#promoCodeErrMsg").show();
		}
	});

	var ProductPurchaseMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.listenTo(Event, 'default', this.hideAll);
			this.listenTo(Event, 'error', this.error);
			this.listenTo(Event, 'creditError', this.error);
			this.listenTo(Event, 'creditForm', this.hideAll);
			this.listenTo(Event, 'credit', this.processing);
			this.listenTo(Event, 'creditPaymentError', this.creditPaymentError);
			this.listenTo(Event, 'creditDeclineError', this.creditDeclineError);
			this.listenTo(Event, 'creditInvalidError', this.creditInvalidError);
			this.listenTo(Event, 'creditAccept', this.creditAccept);
			this.listenTo(Event, 'creditPend', this.creditPend);
			this.listenTo(Event, 'creditDuplicate', this.creditDup);
			this.listenTo(Event, 'paypal', this.processing);
			this.listenTo(Event, 'paypalError', this.paypalError);
			this.listenTo(Event, 'promoSuccess', this.promoAccept);
		},
		
		hideAll: function() {
			this.$("#purchaseBodyMessageError").hide();
			this.$("#purchaseBodyMessageProcessing").hide();
			this.$("#purchaseBodyMessagePaypalError").hide();
			this.$("#purchaseBodyMessageCreditPaymentError").hide();
			this.$("#purchaseBodyMessageCreditDeclineError").hide();
			this.$("#purchaseBodyMessageCreditInvalidError").hide();
			this.$("#purchaseBodyMessageCreditAccept").hide();
			this.$("#purchaseBodyMessageCreditPend").hide();
			this.$("#purchaseBodyMessageCreditDup").hide();
			this.$("#purchaseBodyMessagePromoAccept").hide();
		},
		
		error: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageError").show();
		},
		
		paypalError: function () {
			this.hideAll();
			this.$("#purchaseBodyMessagePaypalError").show();
		},
		
		creditPaymentError: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditPaymentError").show();
		},
		
		creditDeclineError: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditDeclineError").show();
		},
		
		creditInvalidError: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditInvalidError").show();
		},
		
		creditAccept: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditAccept").show();
		},
		
		creditPend: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditPend").show();
		},
		
		creditDup: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageCreditDup").show();
		},
		
		processing: function () {
			this.hideAll();
			this.$("#purchaseBodyMessageProcessing").show();
		},
		
		promoAccept: function () {
			this.hideAll();
			this.$("#purchaseBodyMessagePromoAccept").show();
		}
	});
	
	var ProductPurchaseView = Backbone.View.extend({
		el: $("#purchaseContent"),
		devRegion: false,
		
		initialize: function(options) {
			this.userModel = options.userModel;
			this.devRegion = this.userModel.get('envProfile') != 'production' ? true : false;
			this.message = new ProductPurchaseMessageView({el: this.$("#purchaseMessage"), model: this.model});
			this.content = new ProductPurchaseContentView({el: this.$("#purchaseBodyContent"), model: this.model, userModel: this.userModel});
			this.footer = new ProductPurchaseFooterView({el: this.$("#purchaseFooter"), model: this.model});
			
			this.listenTo(Event, 'paypal', this.initPaypal);
			this.listenTo(Event, 'credit', this.initCredit);						
			
			this.listenTo(this.model, 'reset', this.render);
			
			this.$("#purchaseMethodPaypal").prop('disabled', 'disabled');
			this.$("#purchaseMethodPaypalRadio").addClass('disabled');
			
			_.bindAll(this, 'handleStripeToken');
			//_.bindAll(this, 'resetView');
			
			//$('#purchasePopup').on('hide', this.resetView);
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});		
		},
		
		//resetView: function() {
		//	this.model.fetch();
		//	this.render();
		//},
		
		render: function () {
			Event.trigger("default");
			return this;
		},
		
		initPaypal: function (prodId) {
			//Help prevent double clicks
			if(!this.transWait) {
				this.transWait = true;
				this.trans = new PaypalTrans({userName : this.userModel.get('userName'), prodId : prodId});
				
				this.trans.bind("change", this.processPPToken, this);
				this.trans.bind("error", this.paypalError, this);
				
				this.trans.fetch();
			}
			return this;
		},
		
		processPPToken: function() {
			
			//Express checkout 
			if(this.devRegion){
				window.location.href = "https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" 
					+ this.trans.get("token") 
					+ "&useraction=commit";
			} else {
				window.location.href = "https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" 
					+ this.trans.get("token") 
					+ "&useraction=commit";
			}
			
			//Digital Goods
			//var dg = new PAYPAL.apps.DGFlow({ 
				// the HTML ID of the form submit button which calls setEC 
				//trigger: "submitBtn", 
				// the experience type: instant or mini 
			//	expType: 'instant' 
			//}); 
			//dg.startFlow("https://www.sandbox.paypal.com/incontext?token=" + this.trans.get("token") + "&useraction=commit");
			
			this.transWait = false;
		},
		
		paypalError: function() {
			Event.trigger("paypalError");
			this.transWait = false;
		},
		
		initCredit: function (prodId, cardNum, cvcNum, expMonth, expYear) {
			//Help prevent double clicks
			if(!this.transWait) {
				this.transWait = true;
				
				if(this.devRegion){
					Stripe.setPublishableKey('pk_81c4Mv1jULP0QNFEbPXgcgQ5avN3O');
				} else {
					Stripe.setPublishableKey('pk_8kKq40Vno9keuOjic0S6oi43QOBrI');
				}
				
				this.prodId = prodId;
				
				Stripe.createToken({
						number: cardNum,
						cvc: cvcNum,
						exp_month: expMonth,
						exp_year: expYear
				}, this.handleStripeToken);
			}
			
			return this;
		},
		
		handleStripeToken: function(status, response) {
			if (response.error) {
				Event.trigger("creditPaymentError");
			} else {
				var cardToken = response['id'];
				
				this.trans = new CreditTrans({cardToken: cardToken, userName : this.model.userName, prodId : this.prodId});
				
				this.trans.bind("change", this.processCreditTranResult, this);
				this.trans.bind("error", this.creditError, this);
				
				this.trans.save();
			}
		},
		
		processCreditTranResult: function() {
			switch (this.trans.get('payStatus')) {
				case 'ACCEPTED':
					Event.trigger("creditAccept");
					break;
				case 'PENDING':
					Event.trigger("creditPend");
					break;
				case 'CANCELLED':
					Event.trigger("creditDeclineError");
					break;
				default:
					Event.trigger("creditPaymentError");
					break;
			}
			
			this.transWait = false;
		},
		
		creditError: function(model, error) {
			if (error.status == 400) {
				//Invalid Input
				Event.trigger("creditInvalidError");
				Event.trigger("error:card");
				Event.trigger("error:exp");
				Event.trigger("error:cvc");
			} else if (error.status == 409) {
				//Duplicate transaction
				Event.trigger("creditDuplicate");
			} else {
				Event.trigger("creditPaymentError");
			}
			
			this.transWait = false;
		},
	});
	
	return ProductPurchaseView;  
});